<template>
  <CompanyObjectRefSelect
    v-model="vModel"
    :options="companyMeasureOptions"
    :default-option="defaultOption"
    :mode="mode"
    object-type="company_measure"
    placeholder="Measure"
    external-path="/definitions"
    :external-query="{
      tab: 'measures',
    }" />
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import CompanyObjectRefSelect from '@/components/reports/config/common/CompanyObjectRefSelect'

  export default {
    name: 'CompanyMeasureRefSelect',
    components: {
      CompanyObjectRefSelect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
    props: {
      defaultOption: {
        type: Object,
        default: null,
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
